// Client-side YouTube data extraction
// Transcript extraction is blocked by YouTube on all server IPs
// We get title, description, publishDate from RSS/oEmbed instead

function getVideoId(url) {
  const match = url.match(/(?:v=|youtu\.be\/|\/shorts\/)([a-zA-Z0-9_-]{11})/);
  return match ? match[1] : null;
}

export async function extractYouTubeData(url) {
  const videoId = getVideoId(url);
  if (!videoId) throw new Error('Ugyldig YouTube-URL');

  let title = '';
  let description = '';
  let publishDate = '';

  // Try Vercel function first (gets title/description/date, transcript usually blocked)
  try {
    const res = await fetch('/api/youtube-transcript', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ videoId })
    });
    if (res.ok) {
      const data = await res.json();
      title = data.title || '';
      description = data.description || '';
      publishDate = data.publishDate || '';
      if (data.transcript) {
        return { videoId, title, description, transcript: data.transcript, publishDate, url };
      }
    }
  } catch {}

  // Fallback: get info from YouTube RSS feed via our existing Vercel function
  if (!title || !publishDate) {
    try {
      const feedRes = await fetch('/api/youtube-feed');
      if (feedRes.ok) {
        const feedXml = await feedRes.text();
        const entryRegex = new RegExp(`<entry>[\\s\\S]*?<yt:videoId>${videoId}</yt:videoId>[\\s\\S]*?</entry>`);
        const entryMatch = feedXml.match(entryRegex);
        if (entryMatch) {
          const entry = entryMatch[0];
          if (!title) {
            const t = entry.match(/<title>([^<]+)<\/title>/);
            if (t) title = t[1].replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&#39;/g, "'");
          }
          if (!publishDate) {
            const p = entry.match(/<published>([^<]+)<\/published>/);
            if (p) publishDate = p[1].split('T')[0];
          }
          if (!description) {
            const d = entry.match(/<media:description>([^<]*)<\/media:description>/);
            if (d) description = d[1].replace(/&amp;/g, '&').replace(/&quot;/g, '"');
          }
        }
      }
    } catch {}
  }

  // No transcript available from servers - will need manual paste
  return { videoId, title, description, transcript: '', publishDate, url };
}
